const c="41fa1e60b6c1684711d68115dc2ed20a";export{c as GLOBAL_SEARCH_MODAL_ID};
